<template>
  <div class="p-20-15 template-cards-box" @scroll="scroll" style="padding-top: 0;">
    <div class="template-tools d-flex-c-b">
      <!--      <el-dropdown split-button type="primary" @click="handleClick">-->
      <!--        更多菜单-->
      <!--        <el-dropdown-menu slot="dropdown">-->
      <!--          <el-dropdown-item>导入新的模版</el-dropdown-item>-->
      <!--        </el-dropdown-menu>-->
      <!--      </el-dropdown>-->
      <div>
        <el-button type="primary" @click="createTemplate"><i class="el-icon-plus el-icon--left"></i>新建</el-button>
        <el-button type="primary" @click="selectFile"><i class="el-icon-upload el-icon--left"></i>导入</el-button>
      </div>
      <div>
        <div>

        </div>
        <!--排序-->
        <span style="font-size: 14px;">按照</span>
        <el-select @change="getList" placeholder="最后修改时间" size="mini" style="margin:0 3px;width: 110px;"
                   v-model="listData.orderBy">
          <el-option label="修改时间" value="updated_at"></el-option>
          <el-option label="名称" value="name"></el-option>
          <el-option label="类型" value="type"></el-option>
        </el-select>
        <span style="font-size: 14px;">进行</span>
        <el-select @change="getList" placeholder="降序" size="mini" style="margin:0 30px 0 3px;width: 80px;"
                   v-model="listData.order">
          <el-option label="降序" value="desc"></el-option>
          <el-option label="升序" value="asc"></el-option>
        </el-select>
        <!--分组筛选-->
        <span style="font-size: 14px;">分组</span>
        <el-select @change="getList" placeholder="无" size="mini" style="margin:0 30px 0 3px;width: 80px;"
                   v-model="listData.group_id">
          <el-option label="无" :value="null"></el-option>
          <template v-for="(i) in groups">
            <el-option :label="i.name" :value="i.id"></el-option>
          </template>
        </el-select>
        <!--搜索-->
        <el-input v-model="listData.name" placeholder="搜索模版名称" size="mini" @keyup.enter.native="getList"
                  style="width: 200px;margin-right: 5px;"></el-input>
        <el-button type="primary" @click="getList" size="mini">搜索</el-button>
      </div>
    </div>
    <!--    <div class="d-flex-s-s f-wrap template-cards"  v-loading="templateLoading">-->
    <div class="d-flex-s-s f-wrap template-cards">
      <!--      <div class="template-card add-template-card d-flex-c-c">-->
      <!--        <el-tooltip class="item" effect="dark" content="从本地文件导入模版" placement="top">-->
      <!--          <div class="template-import" @click="selectFile">-->
      <!--            <i class="el-icon-paperclip" style="font-size: 30px;"></i>-->
      <!--          </div>-->
      <!--        </el-tooltip>-->
      <!--        <el-tooltip class="item" effect="dark" content="创建新的模版" placement="top">-->
      <!--          <div class="template-create" @click="createTemplate">-->
      <!--            <i class="el-icon-plus" style="font-size: 30px;"></i>-->
      <!--          </div>-->
      <!--        </el-tooltip>-->
      <!--      </div>-->

      <template v-for="(val,index) in templates">
        <div class="template-card d-flex-c-c f-wrap" :data-id="val.id" @click="modify(val.id)">
          <div class="template-image" :style="`background-image: url('${val.thumbnail}')`"></div>
          <p class="template-name">{{ val.name }}.xlsx</p>
          <p class="template-time fixedText">{{ $moment(val.updated_at).fromNow() }}</p>
          <div class="template-details-box">
            <div class="template-details">
              <div class="compactCard">
                <!--              <i class="el-icon-document" style="font-size: 36px"></i>-->
                <div class="compactCardTitleRegion">
                  <i class="compactCardFileIcon">
                    <!--                    <img :src="xlsx" alt="" style="width: 32px;height: 32px;">-->
                    <!--                    <svg t="1666256035732" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2620" width="200" height="200"><path d="M931.84 655.36c12.288 0 20.48-8.192 20.48-20.48V296.96l-163.84-167.936h-456.704c-45.056 0-81.92 36.864-81.92 81.92v67.584h-137.216c-22.528 0-40.96 18.432-40.96 40.96v405.504c0 22.528 18.432 40.96 40.96 40.96h137.216v53.248c0 45.056 36.864 81.92 81.92 81.92h538.624c45.056 0 81.92-36.864 81.92-81.92v-61.44c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v61.44c0 22.528-18.432 40.96-40.96 40.96h-538.624c-22.528 0-40.96-18.432-40.96-40.96v-53.248h225.28c22.528 0 40.96-18.432 40.96-40.96v-405.504c0-22.528-18.432-40.96-40.96-40.96h-225.28v-67.584c0-22.528 18.432-40.96 40.96-40.96h415.744v106.496c0 32.768 26.624 61.44 61.44 61.44h102.4v296.96c0 12.288 8.192 20.48 20.48 20.48z m-618.496-165.888l45.056-65.536h61.44l-71.68 102.4 86.016 118.784h-63.488l-55.296-77.824-55.296 77.824h-63.488l86.016-118.784-73.728-102.4h63.488l40.96 65.536z m495.616-192.512c-12.288 0-20.48-8.192-20.48-20.48v-90.112l106.496 110.592h-86.016z" p-id="2621"></path><path d="M768 614.4h-102.4c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48zM768 512h-102.4c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48zM768 409.6h-102.4c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48z" p-id="2622"></path></svg>-->
                    <!--                    <svg t="1666256189194" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2987" width="200" height="200"><path d="M205.799024 64.936585H664.850732l231.773658 231.773659v638.376585c0 13.79353-11.18208 24.97561-24.97561 24.97561H205.799024c-13.79353 0-24.97561-11.18208-24.975609-24.97561V89.912195c0-13.79353 11.18208-24.97561 24.975609-24.97561z m448.70681 24.97561H205.799024v845.174634H871.64878V307.055141L654.505834 89.912195z" fill="#B7B7BD" p-id="2988"></path><path d="M664.850732 64.936585l-10.989269 23.477074v196.807804c0 13.79353 11.18208 24.97561 24.97561 24.97561h194.310244L896.62439 296.710244 664.850732 64.936585z m13.986341 49.306849L849.815102 285.221463H678.837073V114.243434z" fill="#B7B7BD" p-id="2989"></path><path d="M255.250732 571.441951m9.990244 0l555.457561 0q9.990244 0 9.990243 9.990244l0 0q0 9.990244-9.990243 9.990244l-555.457561 0q-9.990244 0-9.990244-9.990244l0 0q0-9.990244 9.990244-9.990244Z" fill="#B7B7BD" p-id="2990"></path><path d="M255.250732 707.309268m9.990244 0l555.457561 0q9.990244 0 9.990243 9.990244l0 0q0 9.990244-9.990243 9.990244l-555.457561 0q-9.990244 0-9.990244-9.990244l0 0q0-9.990244 9.990244-9.990244Z" fill="#B7B7BD" p-id="2991"></path><path d="M255.250732 639.37561m9.990244 0l555.457561 0q9.990244 0 9.990243 9.990244l0 0q0 9.990244-9.990243 9.990244l-555.457561 0q-9.990244 0-9.990244-9.990244l0 0q0-9.990244 9.990244-9.990244Z" fill="#B7B7BD" p-id="2992"></path><path d="M255.250732 774.243902m9.990244 0l555.457561 0q9.990244 0 9.990243 9.990244l0 0q0 9.990244-9.990243 9.990244l-555.457561 0q-9.990244 0-9.990244-9.990244l0 0q0-9.990244 9.990244-9.990244Z" fill="#B7B7BD" p-id="2993"></path><path d="M255.250732 842.177561m9.990244 0l555.457561 0q9.990244 0 9.990243 9.990244l0 0q0 9.990244-9.990243 9.990244l-555.457561 0q-9.990244 0-9.990244-9.990244l0 0q0-9.990244 9.990244-9.990244Z" fill="#B7B7BD" p-id="2994"></path><path d="M67.434146 193.810732m15.984391 0l286.72 0q15.98439 0 15.98439 15.98439l0 286.72q0 15.98439-15.98439 15.98439l-286.72 0q-15.98439 0-15.984391-15.98439l0-286.72q0-15.98439 15.984391-15.98439Z" fill="#00C090" p-id="2995"></path><path d="M242.569116 353.23904l89.224866 84.502478c4.337764 4.107988 4.523582 10.954302 0.415595 15.291067-4.107988 4.337764-10.954302 4.523582-15.291068 0.415595l-89.224866-84.502479-84.502478 89.224867c-4.107988 4.337764-10.954302 4.523582-15.291067 0.415594-4.337764-4.107988-4.523582-10.954302-0.415595-15.291067l84.502478-89.224867-89.224866-84.502478c-4.337764-4.107988-4.523582-10.954302-0.415594-15.291067 4.107988-4.337764 10.954302-4.523582 15.291067-0.415594l89.224867 84.502478 84.502478-89.224867c4.107988-4.337764 10.954302-4.523582 15.291067-0.415594 4.337764 4.107988 4.523582 10.954302 0.415594 15.291068l-84.502478 89.224866z" fill="#FFFFFF" p-id="2996"></path></svg>-->
                    <svg t="1666256269538" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="3292" width="200" height="200">
                      <path
                          d="M531.2 0h57.6v96h288c16 0 35.2 0 48 12.8 9.6 19.2 9.6 38.4 9.6 60.8v620.8c0 35.2 3.2 70.4-3.2 105.6-3.2 25.6-28.8 25.6-44.8 25.6H588.8V1024H528c-147.2-32-291.2-64-438.4-96V96l441.6-96zM361.6 313.6c-22.4 51.2-48 99.2-64 153.6-16-48-35.2-96-54.4-144-28.8 0-57.6 3.2-83.2 3.2 28.8 64 60.8 124.8 89.6 188.8-35.2 60.8-64 124.8-99.2 185.6 28.8 0 54.4 3.2 83.2 3.2 19.2-48 44.8-96 60.8-147.2 16 54.4 41.6 102.4 64 153.6 32 3.2 60.8 3.2 92.8 6.4-35.2-70.4-70.4-137.6-105.6-208 35.2-67.2 70.4-134.4 102.4-201.6-28.8 3.2-57.6 6.4-86.4 6.4z m371.2 32v89.6h134.4v-89.6h-134.4z m0-147.2V288h134.4v-89.6h-134.4z m0 284.8v89.6h134.4v-89.6h-134.4z m0 140.8v89.6h134.4V624h-134.4z m0 137.6v89.6h134.4v-89.6h-134.4z m-166.4-416v89.6h112v-89.6h-112z m0-147.2V288h112v-89.6h-112z m0 284.8v89.6h112v-89.6h-112z m0 140.8v89.6h112V624h-112z m0 137.6v89.6h112v-89.6h-112z"
                          fill="#387A47" p-id="3293"></path>
                    </svg>
                  </i>
                  <div class="compactCardTitle">
                    {{ val.name }}
                  </div>
                </div>
                <div class="analyticsActionBarStats">
                  类型：<span>{{ (templateTypeOption.find(e => e.value === val.type) ?? []).label }}</span>
                  <br>
                  分组：<span>{{ val.group_id?((groups.find(e=> e.id==val.group_id)??[]).name):'无分组' }}</span>
                  <br>
                  <!--                  <span @click="userInfo(val.create_user.id)">{{ val.create_user.nickname }}</span>&nbsp;创建-->
                  <!--                  <span @click="userInfo(val.modify_user.id)">{{ val.modify_user.nickname }}</span>&nbsp;最后修改-->
                  <span>{{ val.create_user.nickname }}</span>&nbsp;创建
                  <span>{{ val.modify_user.nickname }}</span>&nbsp;最后修改
                  <br>
                  属于 <span>{{ Number(val.coid) ? coname(val.coid) : '未归属' }}</span> 公司
                </div>
              </div>
              <div class="compactCard" v-if="val.description">
                <div class="compactCard-120">
                  <div class="analyticsActionBar ">
                    <div class="activitiesSection">
                      <h4>描述</h4>
                      <p class="">{{ val.description }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="compactCard historiesCard">
                <div class="compactCard-120">
                  <div class="analyticsActionBar">
                    <div class="activitiesSection">
                      <h4>历史</h4>
                      <div class="historyCardList">
                        <template v-for="(h,index) in val.history">
                          <div class="historyCard d-flex-c-b" @click="templateHistory(h.identifying_code)">
                            <p>{{ h.modify_user.nickname }}</p>
                            <p>{{ $moment(h.created_at).fromNow() }}</p>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <input id="import-input" type="file" value="restore" accept=".template" @change="importTemplate">

      <div class="contextualMenu" :style="`left:${content.left}px;top:${content.top}px;`">
        <div class="contextualMenuItem" @mousedown="open">
          <button class="contextualMenuItemButton">
            打开
          </button>
        </div>
        <div class="contextualMenuItem" @mousedown="rename">
          <button class="contextualMenuItemButton">
            重命名
          </button>
        </div>
        <div class="contextualMenuItem" @mousedown="publish" v-if="selectTemplate.status==='draft'">
          <button class="contextualMenuItemButton">
            发布
          </button>
        </div>
        <div class="contextualMenuItem" @mousedown="unpublish" v-if="selectTemplate.status==='publish'">
          <button class="contextualMenuItemButton">
            取消发布
          </button>
        </div>
        <div class="contextualMenuItem" @mousedown="modifyCoVisible=true;modifyCoid=selectTemplate.coid;"
             v-if="auth.isAdmin()">
          <button class="contextualMenuItemButton">
            修改所属公司
          </button>
        </div>
        <div class="contextualMenuItem" @mousedown="exportTemplate">
          <button class="contextualMenuItemButton">
            导出模版
          </button>
        </div>
        <div class="contextualMenuItem" @mousedown="remove">
          <button class="contextualMenuItemButton">
            删除
          </button>
        </div>
      </div>
    </div>

    <div class="template-tips d-flex-c-c flex-wrap">
      <h6 class="w-100 d-flex-c-c">共{{ listData.count }}条数据</h6>
      <h6 class="w-100 d-flex-c-c">{{ tip }}</h6>
    </div>

    <Modal
        ref="createTemplate"
        :title="'创建模版'"
        :confirm="createTemplateAndRedirect"
        :close="()=>this.$refs.templateRuleForm.resetFields()"
        :formName="'templateRuleForm'"
    >
      <el-form :model="templateForm" :rules="rules" ref="templateRuleForm" label-width="80px">
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="templateForm.name"></el-input>
        </el-form-item>
        <el-form-item label="模版类型" prop="type">
          <el-select
              v-model="templateForm.type"
              class="w-100"
              placeholder="请选择模版类型">
            <el-option
                v-for="item in templateTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属分组" prop="tag">
          <el-select
              v-model="templateForm.group_id"
              filterable
              clearable
              class="w-100"
              placeholder="请选择所属分组">
            <el-option
                v-for="item in groups"
                :key="item.id"
                :label="item.name"
                :value="`${item.id}`">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="模版标签" prop="tag">-->
        <!--          <el-select-->
        <!--              v-model="templateForm.tag"-->
        <!--              multiple-->
        <!--              filterable-->
        <!--              allow-create-->
        <!--              default-first-option-->
        <!--              class="w-100"-->
        <!--              placeholder="请输入模版标签">-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item label="模版描述" prop="description">
          <el-input type="textarea" v-model="templateForm.description"></el-input>
        </el-form-item>
        <el-form-item label="所属公司" prop="coid" v-if="auth.isAdmin()">
          <el-select
              v-model="templateForm.coid"
              class="w-100"
              placeholder="请选择模版所属公司">
            <el-option
                v-for="item in co"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </Modal>


    <el-dialog
        title="提示"
        :visible.sync="modifyCoVisible"
        width="400px">
      <el-select
          v-model="modifyCoid"
          class="w-100"
          placeholder="请选择模版所属公司">
        <el-option
            v-for="item in co"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
    <el-button @click="modifyCoCancel">取 消</el-button>
    <el-button type="primary" @click="modifyCoSubmit">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import xlsx from '@/assets/xlsx.svg'
import Modal from '@/components/Modal'
import fa from "element-ui/src/locale/lang/fa";
import auth from "@/plugins/auth";

export default {
  name: "index",
  components: {
    Modal
  },
  data() {
    return {
      xlsx,
      templates: [],
      groups: [],
      template_handle_id: 0,
      content: {
        left: -9990,
        top: -9990
      },
      templateForm: {
        name: '',
        description: '',
        tag: [],
        type: 'day',
        group_id: null,
        coid: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入模版名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择模版类型', trigger: 'blur'},
        ],
      },
      templateTypeOption: [
        {
          label: '日报表',
          value: 'day',
        },
        {
          label: '月报表',
          value: 'month',
        },
        {
          label: '年报表',
          value: 'year',
        },
        {
          label: '自定义时段报表',
          value: 'config',
        },
      ],
      listData: {
        count: 0,
        skip: 0,
        take: 24,
        name: '',
        orderBy: 'updated_at',
        order: 'desc',
        group_id: null,
      },
      co: [],
      tip: '',
      auth,
      templateLoading: false,
      modifyCoVisible: false,
      modifyCoid: ''
    }
  },
  mounted() {
    this.getList();
    this.getCompany();
    this.getGroup();
  },
  methods: {
    createTemplateAndRedirect() {
      let data = {
        pageMargins: {top: 1, left: 1, right: 1, bottom: 1},
        pageSize: "a4",
        printDirection: "portrait",
        storage: [
          {
            cell: {},
            col: {},
            colLen: 52,
            row: {},
            rowLen: 100,
            images: [],
            merges: [],
            name: 'sheet1'
          },
        ],
      }

      let templateData = {
        name: this.templateForm.name,
        description: this.templateForm.description,
        tag: this.templateForm.tag,
        group_id: this.templateForm.group_id,
        type: this.templateForm.type,
        data: JSON.stringify(data),
        coid: this.templateForm.coid
      }

      this.$http.post('template/create', templateData).then(res => {
        this.$toast('创建成功');
        this.$refs.createTemplate.hide();
        this.$router.push({name: 'TemplateModify', params: {id: res.data.template.id}})
      });
    },
    createTemplate() {
      localStorage.removeItem("webExcel");
      this.$refs.createTemplate.show();
    },
    getGroup() {
      this.groups = [];
      this.$http.post('group/list').then((res) => {
        this.groups = res.data.data;
      }).catch(() => {
      });
    },
    getList() {
      this.templates = [];
      this.$http.post('template/list', {
        ...this.listData,
        skip: 0,
      }).then((res) => {
        this.templates = res.data.items;
        this.listData.skip = res.data.skip;
        this.listData.count = res.data.count;

        if (this.listData.count <= (this.listData.take + this.listData.skip)) this.tip = '已加载全部数据'
        else this.tip = '下拉加载更多数据'
      }).catch(() => {
      }).finally(() => {
        this.contentMenu();
      });
    },
    scroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        if (this.listData.count > (this.listData.take + this.listData.skip)) this.addList();
      }
    },
    addList() {
      this.tip = '正在加载数据中...';
      this.templateLoading = true;
      this.listData.skip = this.listData.skip + this.listData.take;
      this.$http.post('template/list', this.listData).then((res) => {
        this.templates.push(...res.data.items);
        this.listData.skip = res.data.skip;
        this.listData.count = res.data.count;

        if (this.listData.count <= (this.listData.take + this.listData.skip)) this.tip = '已加载全部数据'
        else this.tip = '下拉加载更多数据'

        this.templateLoading = false;
      }).catch(() => {
        this.templateLoading = false;
        this.tip = '网络错误，请刷新重试！'
      }).finally(() => {
        this.contentMenu();
      });
    },
    modify(id) {
      localStorage.removeItem("webExcel");
      this.$router.push({name: 'TemplateModify', params: {id}});
    },
    userInfo(id) {
      this.$router.push({name: 'UserInfo', query: {id}});
    },
    templateHistory(identifying_code) {
      this.$router.push({name: 'TemplateHistory', params: {identifying_code}});
    },
    contentMenu() {
      let contextualMenu = document.getElementsByClassName('contextualMenu')[0];

      document.body.onmousedown = (e) => {
        contextualMenu.setAttribute('style', `left:-1000px;top:-1000px;`);
      }

      for (let dom of document.getElementsByClassName('template-card d-flex-c-c f-wrap')) {
        dom.oncontextmenu = (e) => {
          let c = e.path.find(o => {
            return o._prevClass === "template-details-box";
          });
          if (!c) {
            let left = e.offsetX + dom.offsetLeft + 30,
                top = e.offsetY + dom.offsetTop + 10;
            this.template_handle_id = dom.getAttribute("data-id") ?? this.template_handle_id;
            // contextualMenu.setAttribute('style', `left:${left}px;top:${top}px;`);
            [this.content.left, this.content.top] = [left, top];
          }
          return false;
        }
      }
    },
    open() {
      this.modify(this.template_handle_id);
    },
    remove() {
      this.$confirm('此操作将永久删除该模版, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete('template/remove/' + this.template_handle_id).then((res) => {
          this.$toast("删除模版成功！");
          this.getList();
        }).catch(() => {
        })
      }).catch(() => {
      });
    },
    publish() {
      this.$http.post('template/status/' + this.template_handle_id, {
        status: 'publish'
      }).then((res) => {
        this.$toast("发布成功！");
        this.getList();
      }).catch(() => {
      })
    },
    unpublish() {
      this.$http.post('template/status/' + this.template_handle_id, {
        status: 'draft'
      }).then((res) => {
        this.$toast("取消发布成功！");
        this.getList();
      }).catch(() => {
      })
    },
    exportTemplate() {
      this.$http.get('template/export/' + this.template_handle_id).then((res) => {
        const blob = new Blob([res.data ?? ""], {
          type: 'text/markdown'
        });

        let url = URL.createObjectURL(blob);

        let aTag = document.createElement('a');

        aTag.href = url;
        aTag.download = this.selectTemplate.name + '.template';

        aTag.click();

        this.$toast("导出模版成功！");
      }).catch(() => {
      })
    },
    selectFile() {
      document.getElementById('import-input').click();
    },
    importTemplate() {
      let file = document.getElementById('import-input');

      if ((file.files[0].size ?? 0) == 0) this.$toast("请上传正确的备份文件！", 'danger');
      else if (file.value === '') return false;
      else {
        let reader = new FileReader();
        reader.readAsText(file.files[0], "UTF-8");
        reader.onload = (e) => {
          let data = e.currentTarget.result;
          this.$http.post('template/import', {data}).then((e) => {
            console.log(e)
            this.getList();
            this.$toast("导入模版成功！")

          }).catch(() => {

          }).finally(() => {
            file.value = '';
          });
        }
      }
    },
    getCompany() {
      this.$http.get('uiinterface?reqType=GetCoofUsr').then(res => {
        // console.log(res)
        if (res.data.err === '用户未登录') {
          return;
        }
        this.co = res.data.data;

        //判断公司列表是否不为空
        if ((this.co.length ?? 0) > 0) {
          //默认选择第一个公司
          this.templateForm.coid = this.co[0].id;
        } else {
          //如果公司列表为空
          this.co = [{id: '-1', name: '暂无公司'}];
          this.templateForm.coid = '';
        }
      }).catch(err => {

      });
    },
    rename() {
      this.$prompt('请输入新的模版名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: this.selectTemplate.name
      }).then(({value}) => {
        if (value === this.selectTemplate.name) this.$toast('请输入与之前不同的名称', 'danger');
        else this.$http.post('template/name/' + this.selectTemplate.id, {name: value}).then(res => {
          this.$toast('模版名称修改成功！');
          this.getList();
        });
      }).catch(() => {
      });
    },
    coname(id) {
      for (let o of this.co) {
        if (o.id == id) return o.name;
      }
    },
    modifyCoCancel() {
      this.modifyCoVisible = false;
      this.modifyCoid = '';
    },
    modifyCoSubmit() {
      this.modifyCoVisible = false;
      if (this.selectTemplate.coid === this.modifyCoid) {
        this.modifyCoid = '';
        return this.$toast('请输入与之前不同的所属公司', 'danger');
      }
      this.$http.post('template/coid/' + this.selectTemplate.id, {coid: this.modifyCoid}).then(res => {
        this.modifyCoid = '';
        this.getList();
        this.$toast('修改所属公司成功！');
      })
    },

  },
  computed: {
    selectTemplate() {
      return this.templates.find((e) => {
        return e.id == this.template_handle_id
      }) ?? [];
    }
  }
}
</script>

<style>
* {
  font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
}

.template-cards-box {
  /*min-height: 520px;*/
  /*max-height: calc(100vh - 144px);*/
  height: calc(100vh - 144px);
  overflow-x: hidden;
  overflow-y: scroll;
}


.template-tools {
  height: 80px;
  position: sticky;
  top: 0px;
  width: 100%;
  z-index: 1000;
  background: white;
  padding: 30px 30px 10px 30px;
}

.template-cards {
  position: relative;
}

.template-card {
  width: 160px;
  margin: 5px 10px;
  /*height: 160px;*/
  padding: 10px;
  cursor: pointer;
  transition: .1s background-color;
  position: relative;
}

.template-card:hover {
  background: #f3f2f1;
}

.template-tips {
  height: 40px;
  width: 100%;
  color: #606266;
  padding-top: 20px;

  position: sticky;
  top: 100%;
}

.template-image {
  width: 101px;
  height: 101px;
  background-size: 100px 100px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 1px rgb(1 1 0 / 5%);
  background-repeat: no-repeat;
  background-position: center;
}

.template-name, .template-time {
  display: inline;
  margin-top: 8px;
  text-align: center;
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #323130;
}

.template-name {
  word-wrap: break-word;
  width: 140px;
}

.template-time {
  margin-top: 5px;
  font-size: 12px;
  color: #605e5c;
}

.template-name:hover {
  text-decoration: #1a202c underline;

}

.template-card:hover .template-details-box {
  visibility: visible;
}

.template-details-box {
  position: absolute;
  left: 160px;
  top: 0;
  width: 340px;
  padding: 0 10px;
  visibility: hidden;
}

.template-card:hover .template-details {
  animation-name: details;
  animation-duration: 0.367s;
  animation-timing-function: cubic-bezier(0.1, 0.9, 0.2, 1);
  animation-fill-mode: both;
  /*transition-duration:0.5s !important;!*收缩时间，单位为秒*!*/
  /*transition-delay:1.5s !important;!*收缩延时，单位为秒*!*/
}

.template-card:hover .historiesCard {
  animation-name: histories;
  animation-duration: 1.867s;
  animation-timing-function: cubic-bezier(0.1, 0.9, 0.2, 1);
  animation-fill-mode: both;
}


.template-card:hover .historyCardList {
  overflow-x: hidden;
  animation-name: historyCardList;
  animation-duration: 2s;
  animation-timing-function: cubic-bezier(0.1, 0.9, 0.2, 1);
  animation-fill-mode: both;
}

.template-details {
  position: relative;
  font-size: 14px;
  font-weight: 400;
  border-radius: 2px;
  box-shadow: rgb(0 0 0 / 13%) 0px 6.4px 14.4px 0px, rgb(0 0 0 / 11%) 0px 1.2px 3.6px 0px;
  outline: transparent;
  width: 320px;
  pointer-events: none;
  background: #fff;
  z-index: 999;
  user-select: none;
  opacity: 0;
  cursor: auto;
}

.compactCard {
  padding: 14px 12px 0;
}

.compactCardTitleRegion {
  margin-bottom: 2px;
  display: flex;
  min-height: 40px;
  align-items: center;
  margin-left: 2px;
}

.compactCardFileIcon {
  margin-right: 14px;
}

.compactCardFileIcon svg {
  width: 32px;
  height: 32px;
}

.compactCardTitle {
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  max-width: 200px;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
  white-space: normal;
}

.analyticsActionBarStats {
  padding: 12px 4px 0;
  box-sizing: border-box;
}

.analyticsActionBarStats * {
  color: #0078d4;
  cursor: pointer;
  font-size: 12px;
}

.compactCard-120 {
  pointer-events: auto;
  position: relative;
}

.analyticsActionBar {
  background-color: transparent;
  padding-left: 0;
  padding-right: 0;
  box-sizing: border-box;
  border-top: 1px solid #edebe9;
}

.activitiesSection {
  padding: 16px 0px 10px 4px;
}

.activitiesSection p {
  max-width: 292px;
  word-break: break-word;
}

.historiesCard {
  max-height: 0px;
  /*transition: .4s height;*/
  overflow: hidden;
}

.historiesCard .activitiesSection {
  max-height: 300px;
  /*overflow: scroll;*/
  overflow: hidden;
}

.historyCard {
  margin: 10px 0 5px;
}

.historyCardList {
  overflow: scroll;
  max-height: 250px;
}

@keyframes details {
  0% {
    transform: translate3d(-10px, 0px, 0px);
    pointer-events: none;
    opacity: 0;
  }

  100% {
    transform: translate3d(0px, 0px, 0px);
    pointer-events: auto;
    opacity: 1;
  }
}

@keyframes histories {
  0%, 20% {
    max-height: 1px;
  }

  100% {
    max-height: 500px;
  }
}

.contextualMenu {
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  box-sizing: border-box;
  box-shadow: rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px;
  outline: transparent;
  background-color: rgb(255, 255, 255);
  overflow: hidden auto;
  border-radius: 2px;
  padding: 5px 0px;
  left: -1000px;
  top: -1000px;
}

.contextualMenuItem {
  font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  color: rgb(50, 49, 48);
  position: relative;
  box-sizing: border-box;
  min-width: 100px;
}

.contextualMenuItemButton {
  outline: transparent;
  position: relative;
  font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  color: rgb(0, 0, 0);
  border: none;
  width: 100%;
  height: 36px;
  line-height: 36px;
  display: block;
  cursor: pointer;
  padding: 0px 16px 0px 12px;
  text-align: left;
  border-radius: 0;
}

.add-template-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.template-create, .template-import {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  transition: all .3s;
}


.template-create:hover, .template-import:hover {
  background: rgba(0, 0, 0, 0.09);
  width: 200%;
  /*opacity: .6;*/
}

#import-input {
  height: 0;
  width: 0;
  display: none;
  visibility: hidden;
  opacity: 0;
}

</style>